"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveLayout = void 0;
const react_1 = require("react");
const state_1 = require("../../../state");
const theme_1 = require("../../../theme");
const breakpoint_1 = require("../../breakpoint");
const use_window_size_1 = require("../use-window-size");
const useResponsiveLayout = () => {
    const breakpoints = theme_1.coreBreakpoints;
    const windowSize = (0, use_window_size_1.useWindowSize)();
    const [shoppingPortalState] = (0, state_1.useShoppingPortalStore)();
    const { getDeviceAttributes } = state_1.shoppingPortalSelectors;
    const deviceType = getDeviceAttributes(shoppingPortalState);
    const [helper, setHelper] = (0, react_1.useState)(new ResponsiveLayoutState(breakpoints, windowSize, deviceType));
    (0, react_1.useEffect)(() => {
        setHelper(new ResponsiveLayoutState(breakpoints, windowSize, deviceType));
    }, [windowSize, deviceType, breakpoints]);
    return helper;
};
exports.useResponsiveLayout = useResponsiveLayout;
const currentBreakpoint = (breakpointRanges, width) => {
    return Object.keys(breakpointRanges).find((key) => {
        const [min, max] = breakpointRanges[key];
        return (!min || width >= min) && (!max || width <= max);
    });
};
class ResponsiveLayoutState {
    constructor(breakpoints, windowSize, device) {
        var _a;
        this.windowSize = windowSize;
        this.device = device;
        this.breakpointRanges = (0, breakpoint_1.breakpointsToBreakpointRanges)(breakpoints);
        this.currentBreakpoint = currentBreakpoint(this.breakpointRanges, (_a = windowSize.width) !== null && _a !== void 0 ? _a : 0);
        this.breakpoint = this.breakpoint.bind(this);
        this.deviceType = this.deviceType.bind(this);
        this.above = this.above.bind(this);
        this.below = this.below.bind(this);
    }
    breakpoint(bp) {
        return bp === undefined ? this.currentBreakpoint : this.currentBreakpoint === bp;
    }
    deviceType(deviceType) {
        return deviceType === undefined ? this.device : this.device === deviceType;
    }
    above(bp) {
        const { breakpointRanges, windowSize } = this;
        return {
            get breakpoint() {
                const max = breakpointRanges[bp][1];
                const { width } = windowSize;
                return !!width && !!max && width > max;
            }
        };
    }
    below(bp) {
        const { breakpointRanges, windowSize } = this;
        return {
            get breakpoint() {
                const min = breakpointRanges[bp][0];
                const { width } = windowSize;
                return !!width && !!min && width < min;
            }
        };
    }
}
